import { appPermissions } from '@/libs/auth/permissions/appPermissions';
import { beforeEnterCheckPermission } from './utils/routePermissions';

export default [
  {
    name: 'content-type',
    path: '/contenttype',
    component: () => import('@/views/contentType/ContentType.vue'),
    meta: {
      title: 'هيكلية المحتوى',
    },
    beforeEnter(to, from, next) {
      const { has, redirectTo } = beforeEnterCheckPermission(
        appPermissions.contentType,
      );
      if (has) return next();
      else return next(redirectTo);
    },
  },
];
